module.exports = __webpack_public_path__ + "f63cdb430cdb204c9b57a8c202b88914.svg";